export enum TaskViewMutationTypes {
  TASK_STORE_SET_LIST = 'TASK_STORE_SET_LIST',
  TASK_STORE_SET_LIST_ALL = 'TASK_STORE_SET_LIST_ALL',
  TASK_STORE_SET_LOADING = 'TASK_STORE_SET_LOADING',
  TASK_STORE_SET_LIST_SETTINGS = 'TASK_STORE_SET_LIST_SETTINGS',
  TASK_STORE_SET_LIST_ALL_SETTINGS = 'TASK_STORE_SET_LIST_ALL_SETTINGS',
  SET_NEW_TASKS_COUNT = 'SET_NEW_TASKS_COUNT',
  SET_NEW_TASKS_ALL_COUNT = 'SET_NEW_TASKS_ALL_COUNT',
}
